import React, { useEffect, useState } from "react";

import "css/style.css";

function TopAdd() {
  return (
    <div className="top-add">
			<a href={localStorage.getItem("topLink")} target="_blank">
      	<img className="top-img" src={localStorage.getItem("topImage")}></img>
			</a>
    </div>
  );
}

export default TopAdd;
